// extracted by mini-css-extract-plugin
export var quantityInput = "_hc-0";